import React, { useState, useEffect } from 'react';
import { IonContent, IonText, IonButton, IonInput } from '@ionic/react';

// Note images mapping
const noteImages: Record<string, string> = {
    '₹1': '/assets/coins/1_rupee.png',
    '₹2': '/assets/coins/2_rupee.png',
    '₹5': '/assets/coins/5_rupee.png',
    '₹10': '/assets/coins/10_rupee.png',
    '₹20': '/assets/coins/20_rupee.png',
    '₹50': '/assets/coins/50_rupee.png',
    '₹100': '/assets/coins/100_rupee.png',
};

// Function to generate random money question with exactly 6 notes
const generateMoneyQuestion = () => {
    const items = Object.keys(noteImages); // Use available notes as keys
    const questionItems: string[] = [];
  
    for (let i = 0; i < 6; i++) { // Ensure exactly 6 notes
        const randomItem = items[Math.floor(Math.random() * items.length)];
        questionItems.push(randomItem);
    }
  
    return {
        questionItems,
    };
};

const CountingMoney: React.FC = () => {
    const [question, setQuestion] = useState({
        questionItems: [] as string[],
    });
    const [userAnswer, setUserAnswer] = useState<string>('');
    const [resultMessage, setResultMessage] = useState<string>('');
    const [isCorrect, setIsCorrect] = useState<boolean | null>(null);
    const [showImage, setShowImage] = useState(false);
    const [error, setError] = useState(false);

    useEffect(() => {
        generateNewQuestion();
        document.title = "Mamas Guidance - Class Two - Mathematics - Money - Counting Money"; // Set page title
    }, []);

    const generateNewQuestion = () => {
        const newQuestion = generateMoneyQuestion();
        setQuestion(newQuestion);
        setUserAnswer('');
        setError(false)
        setResultMessage('');
        setIsCorrect(null);
    };

    const calculateTotal = (items: string[]): number => {
        return items.reduce((sum, item) => sum + parseInt(item.replace('₹', ''), 10), 0);
    };

    const handleSubmit = () => {
        const userTotal = parseInt(userAnswer, 10);
        const correctTotal = calculateTotal(question.questionItems);

        if (userTotal === correctTotal) {
            setShowImage(true);
            setTimeout(() => {
                generateNewQuestion();
                setShowImage(false);
                setError(false);
            }, 5000);
        } else {
            setError(true);
        }
    };

    return (
        <>

            {
                showImage === false ?
                <>
                    <div className='contentPart showCenter additionWord'>
                        <div>
                            <IonText>
                            <p>Count the total value of the following notes:</p>
                            </IonText>

                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', marginTop: '20px' }}>
                            {question.questionItems.map((item, index) => (
                                <img
                                key={index}
                                src={noteImages[item]} // Use images from mapping
                                alt={item}
                                style={{
                                    width: '80px',
                                    height: '80px',
                                    border: '1px solid #ccc',
                                    borderRadius: '5px',
                                    padding: '5px',
                                }}
                                />
                            ))}
                            </div>

                            <div className='mb-4' style={{ marginTop: '20px' }}>
                                <input
                                    type="number"
                                    value={userAnswer}
                                    onChange={(e) => setUserAnswer(e.target.value)}
                                    placeholder="Enter your answer (e.g., 50)"
                                    className={`form-control blank-input ${error == true  ? 'error' : ''} `}
                                />
                            </div>
                        
                            <div className='text-center mt-2'>
                                <div className='optionButton' onClick={handleSubmit}>
                                    Submit Answer
                                </div>
                            </div>
                        </div>
                    </div>
                </>
                :
                <>
                    <div className="contentPart showMiddle">
                        <img style={{height: '150px'}} className='img-fluid' src={process.env.REACT_APP_WELDONE_LINK} />
                    </div>
                </>
            }
        </>
    );
};

export default CountingMoney;
